import { StoryEdge } from "../../storyV2/domain/StoryEdge";
import { StoryNode } from "../../storyV2/domain/StoryNode";
import { StoryNodeType } from "../../storyV2/domain/StoryNodeType";
import { JsonUtil } from "../../cutil/JsonUtil";
import { StoryNodeUtil } from "../../storyV2/domain/StoryNodeUtil";
import { StudioProjectAttributesV3NodeData } from "../../project/domain/StudioProjectAttributesV3NodeData";
import { StudioProjectAttributesV2EdgeData, } from "../../project/domain/StudioProjectAttributesV2Edge";
import StoryNodeOptionsUtil from "../../storyV2/domain/StoryNodeOptionsUtil";
import { StoryEdgeOptionsUtil } from "../../storyV2/domain/StoryEdgeOptionsUtil";
import { StoryInputLine, StoryOutputLine } from "../../storyV2/domain/StoryLine";
import { StoryLineOptions } from "../../storyV2/domain/StoryLineOptions";
import { StoryUtil } from "../../storyV2/domain/StoryUtil";
import { cloneDeep } from "@apollo/client/utilities";
import { SubStory } from "../../storyV2/domain/SubStory";
import { StudioProjectAttributesV3Line } from "../../project/domain/StudioProjectAttributesV3Line";
export class SubStoryUtil {
    /**
     * 把V2的数据生成StoryData
     * @param customFuncDest
     */
    static transformV2DataToV3(customFuncDest) {
        const nodes = customFuncDest.nodeArr;
        const storyNodes = nodes
            .map(node => {
            return StoryNodeOptionsUtil.from(node, false);
        })
            .map(options => {
            let node = new StoryNode(options);
            node.content = options.content ?? "";
            return node;
        });
        const v2Edges = customFuncDest.edgeArr;
        const allNodeId = nodes.map(node => Number(node.id.split("-")[1]));
        const allEdgeId = v2Edges.map(edge => Number(edge.id.split("-")[1]));
        // 找到当前数字量的最大值，后续生成line，那么再最大值基础上+1
        let lineIdeMax = [...allNodeId, ...allEdgeId]
            .sort((a, b) => {
            return a - b;
        })
            .last() ?? 1;
        const lineArr = [];
        const storyEdges = v2Edges.map(v2Edge => {
            const targetNode = storyNodes.find(node => node.id == v2Edge.target);
            const storyEdgeOptions = StoryEdgeOptionsUtil.from(v2Edge);
            const storyEdge = new StoryEdge(storyEdgeOptions);
            const id = Number(v2Edge.id.split("-")[1]);
            storyEdge.options.id = `new-edge-${id}`;
            if (targetNode) {
                // outPutLine
                const outputLine = new StoryOutputLine(new StoryLineOptions(`new-line-${lineIdeMax++}`), v2Edge.source, targetNode);
                lineArr.push(outputLine);
                storyEdge.target = outputLine;
            }
            else {
                console.error("create newEdge notOutPutLine error");
            }
            const sourceNode = storyNodes.find(node => node.id === v2Edge.source);
            if (sourceNode) {
                const sourceLine = new StoryInputLine(new StoryLineOptions(`new-line-${lineIdeMax++}`), sourceNode.id, storyEdge);
                sourceNode.lines = [sourceLine];
                lineArr.push(sourceLine);
            }
            else {
                console.error("create newEdge inputOutPutLine error");
            }
            return storyEdge;
        });
        return [storyNodes, storyEdges, lineArr];
    }
    static fromFunc(story, edge, customFuncDest, isFromUIData) {
        /// 根据Project数据构建所有的节点（Node）
        const nodes = (customFuncDest.nodeArr ?? []).filter(x => x.data instanceof StudioProjectAttributesV3NodeData);
        const edges = (customFuncDest.nodeArr ?? [])?.filter(x => x.data instanceof StudioProjectAttributesV2EdgeData);
        let storyNodes = nodes
            .map(node => {
            return StoryNodeOptionsUtil.from(node, isFromUIData);
        })
            .map(options => {
            let node = new StoryNode(options);
            node.content = options.content ?? "";
            return node;
        });
        // const variables = []
        /// 根据Project数据构建所有的边（Edge）
        let storyEdges = edges
            .map(x => StoryEdgeOptionsUtil.from(x))
            .map(options => {
            const edge = new StoryEdge(options);
            return edge;
        });
        const lines = customFuncDest.edgeArr ?? [];
        lines.forEach((line, index) => {
            let source = storyNodes.find(x => x.options.id === line.source);
            let target = storyEdges.find(x => x.options.id === line.target);
            if (source !== undefined && target !== undefined) {
                source.lines.push(new StoryInputLine(new StoryLineOptions(line.id), source.options.id, target));
            }
            source = storyEdges.find(x => x.options.id === line.source);
            target = storyNodes.find(x => x.options.id === line.target);
            if (source !== undefined && target !== undefined) {
                source.target = new StoryOutputLine(new StoryLineOptions(line.id), source.options.id, target);
            }
        });
        storyNodes.forEach(node => {
            /// 查找子节点
            node.children = StoryUtil.findChildrenNode(node, storyNodes);
        });
        // 如果是v2数据结构，那么需要转为v3
        if (!customFuncDest.isV3Function) {
            const result = this.transformV2DataToV3(customFuncDest);
            storyNodes = result[0];
            storyEdges = result[1];
        }
        /// 根据 UI 节点查找 input 节点，并组装 Idea
        const startNodes = StoryUtil.findStartNodes(storyNodes, storyEdges, []);
        // single edges
        const singleEdges = storyEdges.filter(x => x.target === undefined);
        /// 生成 Story 返回
        const newStory = new SubStory("", startNodes, singleEdges, [], "", undefined);
        return this.assembleNewStory(story, edge, newStory, customFuncDest);
    }
    /**
     * 组装一个新的 story
     * @param oldStory
     * @param oldEdge
     * @param newStory
     * @param customFuncDest
     */
    static assembleNewStory(oldStory, oldEdge, newStory, customFuncDest) {
        newStory.findAllNodes();
        // 找到sourceNodes
        const newStorySourceArr = newStory.startNodes;
        if (newStorySourceArr.length < 1) {
            return;
        }
        // 获取new story的sourceNode
        const newStorySourceNode = newStorySourceArr[0];
        // oldEdge target node
        const oldStorySourceNode = StoryUtil.findEdgeSoure(oldStory, oldEdge);
        if (!oldStorySourceNode) {
            return newStory;
        }
        const newStoryV = this.replaceNewStorySourceNode(oldStorySourceNode, newStorySourceNode, newStory);
        return newStoryV;
    }
    /**
     * 替换新的story的sourceNode
     */
    static replaceNewStorySourceNode(oldStorySourceNode, newStorySourceNode, newStory) {
        const newSourceNodeIsNormal = newStorySourceNode.options.type === StoryNodeType.CUSTOMNODE;
        const oldSourceNodIsNormal = oldStorySourceNode.options.type === StoryNodeType.CUSTOMNODE;
        // 都是普通节点
        if (newSourceNodeIsNormal && oldSourceNodIsNormal) {
            newStorySourceNode.content = oldStorySourceNode.content;
            newStorySourceNode.options.displayType = oldStorySourceNode.options.displayType;
            return newStory;
        }
        // newSource是normal且oldSource是group
        if (newSourceNodeIsNormal && !oldSourceNodIsNormal) {
            const copyOldStorySourceNode = cloneDeep(oldStorySourceNode);
            const newStorySourceOldId = newStorySourceNode.id;
            const newId = this.createStoryNodeId(StoryNodeType.CUSTOMGROUP, newStory);
            newStorySourceNode.options.type = StoryNodeType.CUSTOMGROUP;
            newStorySourceNode.lines.forEach(x => {
                if (x.source === newStorySourceOldId) {
                    x.source = newId;
                }
            });
            newStorySourceNode.id = newId;
            newStorySourceNode.options.id = newId;
            newStorySourceNode.content = "";
            const parentId = newStorySourceNode.options.id;
            const createNewIds = copyOldStorySourceNode.children.map(x => this.createStoryNodeId(StoryNodeType.CUSTOMNODE, newStory));
            newStorySourceNode.children = copyOldStorySourceNode.children.map((node, index) => {
                node.options.id = createNewIds[index];
                node.options.parentId = parentId;
                node.lines = [];
                return node;
            });
            return newStory;
        }
        // 都是group
        if (!newSourceNodeIsNormal && !oldSourceNodIsNormal) {
            const copyOldStorySourceNode = cloneDeep(oldStorySourceNode);
            newStorySourceNode.content = "";
            newStorySourceNode.children = this.getNewChildStoryNodes(newStory, copyOldStorySourceNode.children, newStorySourceNode.children, newStorySourceNode.id);
            return newStory;
        }
        // newSource是组，oldSource是普通
        if (!newSourceNodeIsNormal && oldSourceNodIsNormal) {
            const newStorySourceOldId = newStorySourceNode.id;
            const newId = this.createStoryNodeId(StoryNodeType.CUSTOMNODE, newStory);
            newStorySourceNode.options.type = StoryNodeType.CUSTOMNODE;
            newStorySourceNode.options.id = newId;
            newStorySourceNode.id = newId;
            newStorySourceNode.children = [];
            newStorySourceNode.content = oldStorySourceNode.content;
            newStorySourceNode.options.displayType = oldStorySourceNode.options.displayType;
            newStorySourceNode.lines.forEach(line => {
                if (line.source === newStorySourceOldId) {
                    line.source = newId;
                }
            });
        }
        return newStory;
    }
    /**
     * oldStory的当前边的sourceNode和subStory的sourceNode都是一个Group
     * 采取组替换的方式,oldChild.id 和 newChild.id有重复的，那么直接用
     * 若没有重复的就生成新的
     * @param newStory
     * @param oldChildStoryNodes
     * @param newChildStoryNodes
     * @param parentId
     */
    static getNewChildStoryNodes(newStory, oldChildStoryNodes, newChildStoryNodes, parentId) {
        const newNodesId = newChildStoryNodes.map(node => node.id);
        oldChildStoryNodes.map(node => {
            // 旧的storyNodes的childNodes的id 和 newStory的childNodes的id有重复，那么就不创建新的
            let newId = "";
            const id = node.id;
            const canUse = newNodesId.some(x => x === id);
            if (canUse) {
                newId = id;
            }
            else {
                newId = this.createStoryNodeId(node.options.type, newStory);
            }
            node.id = newId;
            node.options.id = newId;
            node.options.parentId = parentId;
            node.lines = [];
        });
        return oldChildStoryNodes;
    }
    /**
     * 生成一个新的storyNodeId
     * @param nodeType
     * @param story
     */
    static createStoryNodeId(nodeType, story) {
        const idPre = nodeType == StoryNodeType.CUSTOMGROUP ? "group" : "editor";
        const idSuf = StoryNodeUtil.maxIdNumber(story) + 1;
        const id = idPre + "-" + idSuf;
        return id;
    }
    // assemble graph data for global context call
    static assembleGraphData(nodes, edges, lines) {
        const projectNodes = nodes.map(node => {
            return StoryNodeOptionsUtil.optionsToProjectNode(node.options, node.content);
        });
        const projectEdges = edges.map(edge => {
            return StoryEdgeOptionsUtil.optionsToProjectEdge(edge.options);
        });
        const projectLines = lines.map(line => {
            const projectLine = new StudioProjectAttributesV3Line();
            projectLine.type = "customNewLine";
            projectLine.id = line.options.id;
            projectLine.source = line.source;
            if (line.target instanceof StoryEdge) {
                projectLine.target = line.target.options.id;
            }
            else if (line.target instanceof StoryNode) {
                projectLine.target = line.target.options.id;
            }
            return projectLine;
        });
        const graphData = {
            v3: {
                nodes: [...projectNodes, ...projectEdges],
                edges: projectLines,
            },
        };
        return JsonUtil.parseFromInstance(graphData);
    }
}
